import { GameDataHandler } from '../GameDataHandler';
import ChunkBase from './ChunkBase';
import { ChunkStageDetails } from './worlds/world';

export const ChunkConditions = {
  ShowEachChunkOnce: 'showEachChunkOnce',
  SkipAfterMinimumProgress: 'skipAfterMinimumProgress'
};
export type ChunkConditionsKeys = keyof typeof ChunkConditions;
export type ChunkConditionsValues = typeof ChunkConditions[ChunkConditionsKeys];

export interface ChunkConditionResult {
  selectedChunks: typeof ChunkBase[];
  stageOrdering: ChunkStageDetails;
  shouldSkipToNextStage: boolean;
}

export class ChunkCondition {
  public shouldGenerate(
    scene: Phaser.Scene,
    selectedChunks: typeof ChunkBase[],
    stageOrdering: ChunkStageDetails,
    shouldSkipToNextStage: boolean
  ): ChunkConditionResult {
    return {
      selectedChunks: selectedChunks,
      stageOrdering: stageOrdering,
      shouldSkipToNextStage: shouldSkipToNextStage
    };
  }
}

export class SkipAfterMinimumProgress extends ChunkCondition {
  public shouldGenerate(
    scene: Phaser.Scene,
    selectedChunks: typeof ChunkBase[],
    stageOrdering: ChunkStageDetails,
    shouldSkipToNextStage: boolean
  ): ChunkConditionResult {
    let minProgress = 10;

    return {
      selectedChunks: selectedChunks,
      stageOrdering: stageOrdering,
      shouldSkipToNextStage: shouldSkipToNextStage || scene.registry.get(GameDataHandler.keys.HighScore) >= minProgress
    };
  }
}

export const chunkConditionsLookup: { [key in ChunkConditionsValues as string]: ChunkCondition } = {
  [ChunkConditions.SkipAfterMinimumProgress]: new SkipAfterMinimumProgress()
};
